module.exports = __webpack_public_path__ + "55973feae4647e6f30753b25597b724f.jpg";